import { render, staticRenderFns } from "./SideNavMenuItem.vue?vue&type=template&id=547203e6&"
import script from "./SideNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideNavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideNavMenuItem.vue"
export default component.exports